import React, { useEffect, useState } from "react";
import baseUrl from "../../../../../../api/baseUrl";
import { useDispatch } from "react-redux";
import {
  setloadeActive,
  setloadeDeactive,
} from "../../../../../../redux/loader/loaderActions";
import CloseIcon from "@mui/icons-material/Close";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PercentIcon from "@mui/icons-material/Percent";

function AddTreatmentOne({ close, type }: any) {
  const [data, setData] = useState([]);
  const dispatch = useDispatch();
  const [edit, setedit] = useState(false);
  const [error, seterror] = useState(false);
  const [errorslash, seterrorslash] = useState(false);
  const [formData, setformData] = useState({
    treatment: "",
    price: 0,
    treatmentid: "",
    type: 0,
    typeId: "",
    subId: "",
    selectedOption: "option1",
    materialCost: 0,
    doctorCommission: 0,
  });

  useEffect(() => {
    dispatch(setloadeActive());
    baseUrl
      .get("alltreatment/findAllTreatment")
      .then((response) => {
        dispatch(setloadeDeactive());
        setData(response.data.data);
      })
      .catch((error) => {
        dispatch(setloadeDeactive());
        console.log(error);
      });
  }, []);

  useEffect(() => {
    setedit(
      typeof type !== "object" ||
        (typeof type === "object" && Object.keys(type).length !== 0)
    );
    if (
      typeof type !== "object" ||
      (typeof type === "object" && Object.keys(type).length !== 0)
    ) {
      if (type.type === "main") {
        setformData({
          ...formData,
          treatmentid: type?.treatmentid,
          treatment: type?.treatment,
          price: type?.price,
          materialCost: isNaN(type?.materialCost) ? 0 : type?.materialCost,
          doctorCommission: isNaN(type?.doctorCommission) ? 0 : type?.doctorCommission,
          selectedOption: "option1",
        });
      } else if (type.type === "sub") {
        setformData({
          ...formData,
          treatmentid: type?.treatmentid,
          treatment: type?.treatment,
          typeId: type?.subId,
          price: type?.price,
          materialCost: isNaN(type?.materialCost) ? 0 : type?.materialCost,
          doctorCommission: isNaN(type?.doctorCommission) ? 0 : type?.doctorCommission,
          selectedOption: "option2",
        });
      } else if (type.type === "subsub") {
        setformData({
          ...formData,
          treatmentid: type?.treatmentid,
          treatment: type?.treatment,
          typeId: type?.subId,
          subId: type?.subsubId,
          price: type?.price,
          materialCost: isNaN(type?.materialCost) ? 0 : type?.materialCost,
          doctorCommission: isNaN(type?.doctorCommission) ? 0 : type?.doctorCommission,
          selectedOption: "option3",
        });
      }
    }
  }, [type]);

  const handleChange = (e: any) => {
    if (e.target.name === "doctorCommission") {
      const numericValue = e.target.value.replace(/e/g, 0);
      if (/^\d{0,2}$/.test(numericValue)) {
        setformData({ ...formData, [e.target.name]: numericValue });
      }
    } else {
      setformData({ ...formData, [e.target.name]: e.target.value });
    }
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();

    if (formData.treatment === "") {
      seterror(true);
      return;
    }

    if (formData.treatment.includes("/")) {
      seterrorslash(true);
      return;
    }

    if (!edit) {
      if (formData?.selectedOption === "option2") {
        baseUrl
          .post("alltreatment/createTreatmentType", formData)
          .then((response) => {
            if (response.data.success) close(false);
          })
          .catch((error) => console.log(error));
      } else if (formData?.selectedOption === "option3") {
        baseUrl
          .post("alltreatment/createTreatmentSubType", formData)
          .then((response) => {
            if (response.data.success) close(false);
          })
          .catch((error) => console.log(error));
      } else {
        baseUrl
          .post("alltreatment/createAllTreatment", formData)
          .then((response) => {
            if (response.data.success) close(false);
          })
          .catch((error) => console.log(error));
      }
    } else {
      if (formData?.selectedOption === "option2") {
        baseUrl
          .patch("alltreatment/updateTreatmentType", formData)
          .then((response) => {
            if (response.data.success) close(false);
          })
          .catch((error) => console.log(error.response.data));
      } else if (formData?.selectedOption === "option3") {
        baseUrl
          .patch("alltreatment/updateTreatmentSubType", formData)
          .then((response) => {
            if (response.data.success) close(false);
          })
          .catch((error) => console.log(error));
      } else {
        baseUrl
          .patch("alltreatment/updateAllTreatment", formData)
          .then((response) => {
            if (response.data.success) close(false);
          })
          .catch((error) => console.log(error));
      }
    }
  };

  const radioOptions = [
    { value: "option1", label: "Treatment", id: "treatment" },
    { value: "option2", label: "Type", id: "Types" },
    { value: "option3", label: "Subtype", id: "SubTypes" },
  ];

  const commissionAmount =
    (formData.price - formData.materialCost) * (formData.doctorCommission / 100);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="px-6 py-4 bg-gradient-to-r from-primary to-primaryLight flex items-center justify-between sticky top-0">
          <div className="flex items-center gap-3">
            <MedicalServicesIcon className="text-white" sx={{ fontSize: 24 }} />
            <h2 className="text-lg font-bold text-white">
              {edit ? "Edit Treatment" : "Add Treatment"}
            </h2>
          </div>
          <button
            onClick={() => close(false)}
            className="w-8 h-8 rounded-lg bg-white/20 hover:bg-white/30 flex items-center justify-center text-white transition-colors"
          >
            <CloseIcon sx={{ fontSize: 20 }} />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <div className="p-6 space-y-4">
            {/* Radio Options */}
            <div className="flex gap-2 p-1 bg-slate-100 rounded-xl">
              {radioOptions.map((option) => (
                <label
                  key={option.value}
                  className={`flex-1 text-center py-2 rounded-lg cursor-pointer transition-all text-sm font-medium ${
                    formData.selectedOption === option.value
                      ? "bg-white text-indigo-600 shadow-sm"
                      : "text-slate-500 hover:text-slate-700"
                  } ${edit ? "opacity-50 cursor-not-allowed" : ""}`}
                >
                  <input
                    type="radio"
                    value={option.value}
                    checked={formData.selectedOption === option.value}
                    onChange={handleChange}
                    name="selectedOption"
                    disabled={edit}
                    className="hidden"
                  />
                  {option.label}
                </label>
              ))}
            </div>

            {/* Treatment Select */}
            {formData.selectedOption !== "option1" && (
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1.5">
                  Select Treatment
                </label>
                <select
                  onChange={handleChange}
                  value={formData.treatmentid}
                  name="treatmentid"
                  disabled={edit}
                  className="w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all disabled:opacity-50"
                >
                  <option value="">Select</option>
                  {data
                    ?.filter((item: any) => item.status1 === true)
                    ?.map((item: any, i: number) => (
                      <option key={i} value={item._id}>
                        {item.treatment}
                      </option>
                    ))}
                </select>
              </div>
            )}

            {/* Type Select */}
            {formData.selectedOption === "option3" && (
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1.5">
                  Select Type
                </label>
                <select
                  onChange={handleChange}
                  value={formData.typeId}
                  name="typeId"
                  disabled={edit}
                  className="w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all disabled:opacity-50"
                >
                  <option value="">Select</option>
                  {data
                    ?.filter(
                      (item: any) =>
                        item._id === formData.treatmentid && item.status1 === true
                    )
                    .map((filteredItem: any) => filteredItem.type)
                    ?.flat()
                    ?.filter((items: any) => items.status2 === true)
                    .map((item: any, i: number) => (
                      <option key={i} value={item._id}>
                        {item.treatment}
                      </option>
                    ))}
                </select>
              </div>
            )}

            {/* Treatment Name */}
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1.5">
                Treatment Name <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                onChange={handleChange}
                value={formData.treatment}
                name="treatment"
                disabled={edit}
                placeholder="Enter treatment name"
                className="w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all disabled:opacity-50"
              />
              {formData.treatment === "" && error && (
                <p className="mt-1 text-sm text-red-500">Treatment name is mandatory</p>
              )}
              {formData.treatment.includes("/") && errorslash && (
                <p className="mt-1 text-sm text-red-500">Do not include "/"</p>
              )}
            </div>

            {/* Price */}
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1.5">
                <div className="flex items-center gap-1">
                  <AttachMoneyIcon sx={{ fontSize: 16 }} />
                  Price
                </div>
              </label>
              <input
                type="number"
                onChange={handleChange}
                value={formData.price}
                name="price"
                className="w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all"
              />
            </div>

            {/* Material Cost */}
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1.5">
                Material Cost
              </label>
              <input
                type="number"
                onChange={handleChange}
                value={formData.materialCost}
                name="materialCost"
                className="w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all"
              />
            </div>

            {/* Doctor Commission */}
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1.5">
                <div className="flex items-center gap-1">
                  <PercentIcon sx={{ fontSize: 14 }} />
                  Doctor Commission
                </div>
              </label>
              <div className="flex items-center gap-3">
                <input
                  type="number"
                  onChange={handleChange}
                  value={formData.doctorCommission}
                  name="doctorCommission"
                  className="flex-1 px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all"
                />
                <div className="px-4 py-2.5 bg-emerald-50 text-emerald-600 rounded-xl font-semibold min-w-[100px] text-center">
                  = {commissionAmount.toFixed(2)}
                </div>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="px-6 py-4 bg-slate-50 border-t border-slate-100 flex justify-end gap-3 sticky bottom-0">
            <button
              type="button"
              onClick={() => close(false)}
              className="px-5 py-2.5 text-slate-600 bg-white border border-slate-200 rounded-xl hover:bg-slate-50 transition-colors font-medium"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-5 py-2.5 bg-gradient-to-r from-primary to-primaryLight text-white rounded-xl hover:shadow-lg hover:shadow-primary/20 transition-all font-medium"
            >
              {edit ? "Update" : "Add Treatment"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddTreatmentOne;
